import moment from 'moment';
import { RangeModelComparator } from './comparators/range-model-comparator';
import {
  RangeFilterModel,
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { FilterResultFacade } from '../filter-result-facade';
import {
  structureValueGetter,
  YEARS_LIMIT
} from '../../../grid/utils/value-getters/structure';
import { FilterHandlerBase } from './base/filter-handler-base';

export class DealStructureFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<RangeFilterModel>;

  get name(): string {
    return CalendarGridColumnName.Structure;
  }

  get isInclusiveExclusive(): boolean {
    return false;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    // Set structure year through setFilterService (the config service)
    // In ag-grid 31, this is how filters are configured
    params.setFilterService.year = params.filterOptions.year;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.year;
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(options): IFilterComparator<RangeFilterModel> {
    if (!this.comparator) {
      this.comparator = new RangeModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const dealStructure = params.filters[this.name];
    const data = params.deal;
    const context = params.context;
    let dealStructureFilterPassed = true;
    if (dealStructure) {
      const value = structureValueGetter({
        data,
        context
      }) as Array<{
        year: number;
        par: number;
      }>;

      const years = value.filter((y) => y.par > 0);
      const MAX_YEAR = moment().year() + YEARS_LIMIT;
      dealStructureFilterPassed =
        years.length &&
        years.some(({ year }) => {
          if (dealStructure.model.maxValue === MAX_YEAR) {
            return year >= dealStructure.model.minValue;
          } else {
            return (
              year >= dealStructure.model.minValue &&
              year <= dealStructure.model.maxValue
            );
          }
        });
    }
    result.applyDealFilerResult(data.id, this.name, dealStructureFilterPassed);

    return dealStructureFilterPassed;
  }
}
